/**
 * rtdb.ts — Firebase Realtime Database (WebRTC 시그널링용)
 * Phase 6: LandTrust 매물 라이브투어 + 화상상담
 * Firebase 프로젝트: aloha-global (GenomicAI 공용)
 */

import { initializeApp, getApps } from 'firebase/app';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: 'aloha-global.firebaseapp.com',
  databaseURL: 'https://aloha-global-default-rtdb.asia-southeast1.firebasedatabase.app',
  projectId: 'aloha-global',
  storageBucket: 'aloha-global.firebasestorage.app',
};

const app = getApps().length > 0 ? getApps()[0] : initializeApp(firebaseConfig);

export const db = getDatabase(app);

/** 8자리 랜덤 상담 ID 생성 */
export function generateConsultId(): string {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  return Array.from(
    { length: 8 },
    () => chars[Math.floor(Math.random() * chars.length)]
  ).join('');
}
